import { db } from '@/backend/firebase/firebase';
import { createFirestoreRefs, createConverter } from '@/shared/lib/firestore-refs-factory';

// Initialize the refs with this package's specific DB instance
const refs = createFirestoreRefs(db);

// Export exactly what the package expects
export const {
  fieldToFilter,
  tasaDoc,
  ownerRef,
  ownersCol,
  businessRef,
  businessesCol,
  publicRef,
  slugRef,
  slugsCol,
  transactionsCol,
  transactionRef,
  balancesCol,
  balanceDoc,
  adminSettingsRef,
  adminPrivateRef,
  adminBillingCol,
  legalVersionsCol,
  userLegalAcceptancesCol,
  settlementsCol,
  settlementRef,
  expensesCol,
  globalPaymentMethodsDoc,
  marketingConfigRef,
  productsCol,
  productRef,
  appointmentRef,
  appointmentsCol,
  saleRef,
  salesCol,
  clientsCol,
  clientDoc,
  servicesCol,
  serviceDoc,
  marketingThreadsCol,
  marketingThreadRef,
  marketingThreadMessagesCol,
  // --- TuNomina Core Nested ---
  employeesCol,
  employeeRef,
  payrollCyclesCol,
  payrollCycleRef,
} = refs;

// Compatibility aliases (if needed by older code points)
export const businessRef_legacy = ownerRef;

// Re-export the converter just in case it's used directly anywhere
export const converter = createConverter;
